import { Flex } from '@/components';
import { useAuthContext } from '@/providers';
import { AuthState } from '@/providers/auth';
import { getFirstAccessiblePath } from '@/menu-items/first-accessible-path';
import { CircularProgress } from '@mui/material';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const AuthCallbackPage: FC = () => {
	const { user, authState } = useAuthContext();
	const navigate = useNavigate();

	useEffect(() => {
		if (authState === AuthState.SignedIn) {
			navigate(getFirstAccessiblePath(user), { replace: true });
		} else if (authState === AuthState.SignedOut || authState === AuthState.NoAccess) {
			navigate('/auth', { replace: true });
		}
	}, [authState, user, navigate]);

	return (
		<Flex justifyCenter height="100vh" sx={{ alignItems: 'center' }}>
			<CircularProgress />
		</Flex>
	);
};
